/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SVGIcon } from "@nordcloud/gnui";
import { CostMappingAlgorithm } from "./types";

export const options = new Map([
  [
    CostMappingAlgorithm.Proportional,
    {
      label: "Proportionally",
      desc: "Cost will be assigned proportionally to other spends",
      icon: <SVGIcon size="lg" name="proportional" />,
    },
  ],
  [
    CostMappingAlgorithm.Equal,
    {
      label: "Equally",
      desc: "Cost will be assigned equally between all or selected business units",
      icon: <SVGIcon size="lg" name="equal" />,
    },
  ],
  [
    CostMappingAlgorithm.Manual,
    {
      label: "Manually",
      desc: "Costs will be assigned by custom rules to selected business units",
      icon: <SVGIcon size="lg" name="gear" />,
    },
  ],
]);

export const optionsNames = [...options.keys()];
